import Dropdown from '@common/components/dropdown';
import NumericInput from '@common/components/numericInput';
import { useTranslation } from '@common/hooks/translation';
import React from 'react';
import { countryCodes } from '../constants/countryPhoneCodes';

export const PhoneFields = ({
  name, value, onChange, errorMessage, placeHolder, maxLength = 15, customCode,
}) => {
  const t = useTranslation();
  const phoneCodes = new Set([...countryCodes.map((item) => item)]);

  return (
    <>
      <div className="popup-txt">
        {' '}
        {t(name)}
      </div>
      <div className="input-row">
        {customCode
          ? (
            <input
              type="text"
              className="custom-input"
              readOnly
              value={customCode}
            />
          )
          : (
            <Dropdown
              className="code-select"
              value={value.code}
              onChange={(option) => onChange({
                ...value,
                code: option.value,
              })}
              options={[...phoneCodes].map((item) => ({
                value: item.phoneCode,
                name: item.phoneCode,
                countryAlias: item.countryAlias,
              })) || []}
            />
          )}
        <NumericInput
          maxLength={maxLength - value.code.length}
          key={name}
          className="numeric-input"
          value={value.phone}
          placeholder={placeHolder}
          onChange={(item) => onChange({
            ...value,
            phone: item,
          })}
        />

      </div>
      {!!errorMessage && <div className="error-message">{t(errorMessage)}</div>}
    </>
  );
};
